import React, { useState, useEffect, useRef, useCallback } from "react";
import Header from "./Header.js";
import Footer from "./Footer.js";
import Select from "react-select";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./Style.css";
import { TailSpin } from "react-loader-spinner";
import Add_assignedpackages from "../../Components/Admin_components/add_assignedpackages.js";
import Update_assignedPackages from "../../Components/Admin_components/update_assignedPackages.js";
import Delete_assignedpackages from "../../Components/Admin_components/delete_assignedpackages.js";
import "../../Api/apiUrls";
import {
  getAdminAssignedPackages,
  assignedPackagesExcel,
  getAdminPassManagement,
} from "../../Api/apiUrls";
import ViewPassScheduleBooked from "./viewPassScheduleBooked.js";

function PassManagement() {
  // Modal states
  const [modalAdd_assignedpackagesIsOpen, setAdd_assignedpackagesModalIsOpen] = useState(false);
  const [modalUpdate_assignedPackagesIsOpen, setUpdate_assignedPackagesModalIsOpen] = useState(false);
  const [modalDelete_assignedpackagesIsOpen, setDelete_assignedpackagesIsOpen] = useState(false);
  const [modalUpdate_packagesIsOpen, setUpdate_packagesModalIsOpen] = useState(false);
  
  // Selected items for modals
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedPackageId, setSelectedPackageId] = useState(null);
  
  // Filter and search states
  const [selectedStatus, setSelectedStatus] = useState({ value: "All", label: "All" });
  const [selectedFilter, setSelectedFilter] = useState({ value: "All", label: "All" });
  const [selectedType, setSelectedType] = useState({ value: "All", label: "All" });
  const [selectedPass, setSelectedPass] = useState({ value: "All", label: "All" });
  const [selectedTransaction, setSelectedTransaction] = useState({ value: "All", label: "All" });
  const [searchQuery, setSearchQuery] = useState("");
  const [appliedSearchQuery, setAppliedSearchQuery] = useState("");
  
  // Data states
  const [passManagement, setPassManagement] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [pagination, setPagination] = useState({ current_page: 1, total_pages: 1 });
  
  // Loading states
  const [isLoading, setIsLoading] = useState(true);
  const [isFetching, setIsFetching] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);

  const observer = useRef();
  const searchInputRef = useRef();

  // Filter options
  const filter = [
    { value: "All", label: "All" },
    { value: "Featured", label: "Featured" },
    { value: "Sponsored", label: "Sponsored" },
  ];

  const type = [
    { value: "All", label: "All" },
    { value: "Workshop", label: "Workshop" },
    { value: "Venue", label: "Venue" },
    { value: "News", label: "News" },
  ];

  const transaction = [
    { value: "All", label: "All" },
    { value: "Success", label: "Success" },
    { value: "Failed", label: "Failed" },
    { value: "On Hold", label: "On Hold" },
  ];

  const status = [
    { value: "All", label: "All" },
    { value: "Active", label: "Active" },
    { value: "Expired", label: "Expired" },
    { value: "Published", label: "Published" },
  ];

  const Pass = [
    { value: "All", label: "All" },
    { value: "Annual", label: "Annual" },
    { value: "Monthly", label: "Monthly" },
    { value: "Quarterly", label: "Quarterly" },
    { value: "Half_Yearly", label: "Half_Yearly" },
  ];

  // Modal handlers
  const openAdd_assignedpackages = () => {
    setAdd_assignedpackagesModalIsOpen(true);
  };

  const closeAdd_assignedpackages = () => {
    setAdd_assignedpackagesModalIsOpen(false);
  };

  const openUpdate_assignedPackages = () => {
    setUpdate_assignedPackagesModalIsOpen(true);
  };

  const closeUpdate_assignedPackages = () => {
    setUpdate_assignedPackagesModalIsOpen(false);
  };

  const openDelete_assignedpackages = (userId) => {
    setSelectedUserId(userId);
    setDelete_assignedpackagesIsOpen(true);
  };

  const closeDelete_assignedpackages = () => {
    setDelete_assignedpackagesIsOpen(false);
  };

  const closeUpdate_packages = () => {
    setUpdate_packagesModalIsOpen(false);
  };

  const handleClick = (id) => {
    setUpdate_packagesModalIsOpen(true);
    setSelectedPackageId(id);
  };

  // Filter handlers
  const handleStatusChange = (selectedOption) => {
    setSelectedStatus(selectedOption);
    setPage(1); // Reset to first page when filter changes
    setPassManagement([]); // Clear existing data
  };

  const handleFilterChange = (selectedOption) => {
    setSelectedFilter(selectedOption);
    setPage(1);
    setPassManagement([]);
  };

  const handleTypeChange = (selectedOption) => {
    setSelectedType(selectedOption);
    setPage(1);
    setPassManagement([]);
  };

  const handlePassChange = (selectedOption) => {
    setSelectedPass(selectedOption);
    setPage(1);
    setPassManagement([]);
  };

  const handleTransactionChange = (selectedOption) => {
    setSelectedTransaction(selectedOption);
    setPage(1);
    setPassManagement([]);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const handleSearchSubmit = () => {
    setAppliedSearchQuery(searchQuery);
    setPage(1);
    setPassManagement([]);
  };

  const handleKeyPress = (event) => {
    if (event.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  const clearSearch = () => {
    setSearchQuery("");
    setAppliedSearchQuery("");
    setPage(1);
    setPassManagement([]);
  };

  // Build API query parameters
  const buildQueryParams = useCallback((pageNum) => {
    const params = new URLSearchParams();
    params.append('page', pageNum);
    params.append('page_size', 50);
    
    if (appliedSearchQuery) params.append('search', appliedSearchQuery);
    if (selectedStatus.value !== 'All') params.append('status', selectedStatus.value);
    if (selectedPass.value !== 'All') params.append('pass_type', selectedPass.value);
    if (selectedTransaction.value !== 'All') params.append('transaction_status', selectedTransaction.value);
    
    return params.toString();
  }, [appliedSearchQuery, selectedStatus, selectedPass, selectedTransaction]);

  // Fetch data with pagination
  const fetchPassManagement = useCallback(async (pageNum = 1) => {
    if (pageNum > pagination.total_pages && pagination.total_pages > 0) {
      setHasMore(false);
      return;
    }
    
    setIsFetching(true);
    try {
      const queryParams = buildQueryParams(pageNum);
      const response = await fetch(`${getAdminPassManagement}?${queryParams}`);
      if (!response.ok) throw new Error("Network response was not ok");
      
      const data = await response.json();
      const newPassManagement = data.data.PassManagement || [];
      
      if (pageNum === 1) {
        setPassManagement(newPassManagement);
        setPagination(data.data.pagination || { current_page: 1, total_pages: 1 });
        setTotalItems(data.data.pagination?.total_items || 0);
      } else {
        setPassManagement(prev => [...prev, ...newPassManagement]);
      }
      
      setHasMore(pageNum < data.data.pagination?.total_pages);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsFetching(false);
      setIsLoading(false);
    }
  }, [buildQueryParams, pagination.total_pages]);

  useEffect(() => {
    fetchPassManagement(page);
  }, [page, fetchPassManagement]);

  // Infinite scroll observer
  const lastPassManagementElementRef = useCallback(node => {
    if (isFetching || !hasMore) return;
    if (observer.current) observer.current.disconnect();
    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting) {
        setPage(prev => prev + 1);
      }
    });
    if (node) observer.current.observe(node);
  }, [isFetching, hasMore]);

  const formatCreatedAt = (createdAt) => {
    if (!createdAt) return "--";
    const createdAtDate = new Date(createdAt);
    if (isNaN(createdAtDate)) return "--";
    
    const datePart = createdAtDate.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
    });
    
    const timePart = createdAtDate.toLocaleTimeString("en-GB", {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    });
    
    return `${datePart} - ${timePart}`;
  };

  const handleDownloadClick = () => {
    window.open(assignedPackagesExcel, "_blank");
  };

  useEffect(() => {
    const hasReloaded = localStorage.getItem('hasReloaded');
    if (!hasReloaded) {
      localStorage.setItem('hasReloaded', 'true');
      window.location.reload();
    }
  }, []);

  return (
    <div>
      <Header></Header>
      {modalUpdate_packagesIsOpen && (
        <ViewPassScheduleBooked
          id={selectedPackageId}
          onClose={closeUpdate_packages}
        />
      )}
      {modalAdd_assignedpackagesIsOpen && (
        <Add_assignedpackages onClose={closeAdd_assignedpackages} />
      )}
      {modalUpdate_assignedPackagesIsOpen && (
        <Update_assignedPackages onClose={closeUpdate_assignedPackages} />
      )}
      {modalDelete_assignedpackagesIsOpen && (
        <Delete_assignedpackages
          userId={selectedUserId}
          onClose={closeDelete_assignedpackages}
        />
      )}
      <main id="main" className="main">
        <div className="pagetitle">
          <h1>Pass Management</h1>
        </div>
        <section className="section">
          <div className="card p-2">
            <div className="parent col-md-12 row mt-2">
              <div className="row">
                <div className="child col-md-2" style={{ padding: "5px" }}>
                  <div className="input-group">
                    <input
                      type="text"
                      ref={searchInputRef}
                      style={{
                        borderRadius: "5px",
                        height: "37px",
                        padding: "10px",
                        border: "1px solid lightgrey ",
                        width: "100%",
                      }}
                      onChange={handleSearchChange}
                      onKeyPress={handleKeyPress}
                      value={searchQuery}
                      placeholder="Search..."
                    />
                    {searchQuery && (
                      <button 
                        className="btn btn-outline-secondary" 
                        type="button"
                        onClick={clearSearch}
                        style={{ marginLeft: '5px' }}
                      >
                        <i className="bi bi-x"></i>
                      </button>
                    )}
                    <button 
                      className="btn btn-primary" 
                      type="button"
                      onClick={handleSearchSubmit}
                      style={{ marginLeft: '5px' }}
                    >
                      Search
                      {/* <i className="bi bi-search"></i> */}
                    </button>
                  </div>
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <Select
                    options={status}
                    placeholder="Select Status"
                    value={selectedStatus}
                    onChange={handleStatusChange}
                  />
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <Select
                    options={Pass}
                    placeholder="Select pass"
                    value={selectedPass}
                    onChange={handlePassChange}
                  />
                </div>
                <div className="col-md-2" style={{ padding: "5px" }}>
                  <Select
                    options={transaction}
                    placeholder="Select transaction"
                    value={selectedTransaction}
                    onChange={handleTransactionChange}
                  />
                </div>
              </div>
            </div>
            
            <div className="table-responsive">
              {isLoading ? (
                <div style={{ marginTop: "50px", marginLeft: "50%" }}>
                  <TailSpin color="black" width={50} />
                </div>
              ) : passManagement.length > 0 ? (
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Sr.no</th>
                      <th scope="col">Customer</th>
                      <th scope="col">Pass</th>
                      <th scope="col">Details</th>
                      <th scope="col">Order ID</th>
                      <th scope="col">Gift Card</th>
                      <th scope="col">Price</th>
                      <th scope="col">Brand Respresentative</th>
                      <th scope="col">Brand Representative Commission (in percentage)</th>
                      <th scope="col">Start Month</th>
                      <th scope="col">End Month</th>
                      <th scope="col">Transaction Status</th> 
                      <th scope="col">Purchased At</th>
                      <th scope="col">Status</th> 
                    </tr>
                  </thead>
                  <tbody id="tableBody">
                    {passManagement.map((item, index) => (
                      <tr 
                        key={`${item.id}-${index}`}
                        ref={index === passManagement.length - 1 ? lastPassManagementElementRef : null}
                      >
                        <th scope="row">{(pagination.current_page - 1) * 50 + index + 1}</th>
                        <td>
                          {item?.users?.name || "---"}
                          <br />
                          {item?.users?.email || "---"}
                          <br />
                          {item.users?.mobileNumber || "---"}
                        </td>
                        <td>
                          {item?.passes?.title || "---"} <br />
                          {item?.passes?.duration_type || "---"}
                        </td>
                        <td style={{textAlign:'center'}}>
                          <a onClick={() => handleClick(item.id)} style={{ cursor: 'pointer' }}>
                            <i className="bi bi-eye-fill"></i>
                          </a>
                        </td>
                        <td>
                          {item?.transaction?.order_id || "---"}
                        </td>
                        <td>
                          {item?.gift_card?.card_code || "---"}
                        </td>
                        <td>
                          {item?.price}
                          {item?.discount_coupon?.code 
                            ? ` (${item?.discount_coupon?.code}${
                                item?.discount_coupon?.discount_value 
                                  ? ` (${item?.discount_coupon?.discount_value}%)` 
                                  : ""
                              })`
                            : ""}
                        </td>
                        <td>
                          {item?.brand_representative?.name || "---"}
                          <br />
                          {item?.brand_representative?.code || "---"}
                          <br />
                          {item?.brand_representative?.email || "---"}
                          <br />
                          {item?.brand_representative?.mobileNumber || "---"}
                        </td>
                        <td>
                          {item?.br_commission || "0"}
                        </td>
                        <td>
                          {item?.start_month || "---"}
                        </td>
                        <td>
                          {item?.end_month || "---"}
                        </td>
                        <td>
                          {item?.transaction?.transaction_status || "---"}
                        </td>
                        <td>
                          {formatCreatedAt(item?.created_at)}
                        </td>
                        <td>
                          {item?.status || "---"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              ) : (
                <h3 style={{ textAlign: "center" }}> No data available </h3>
              )}

              {isFetching && (
                <div className="text-center py-3">
                  <TailSpin color="#0d6efd" width={50} />
                </div>
              )}
            </div>

            <div className="p-3 bg-dark text-white rounded-bottom">
              Showing {passManagement.length} of {totalItems} total passes
              {hasMore && " - scroll to load more"}
            </div>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  );
}

export default PassManagement;